// extracted by mini-css-extract-plugin
export default {"SimpleSelect":"EaXztiEz"};
    if(module.hot) {
      // 1764331279837
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  